// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"RowLayout_cardContainer__1-GzI","promptRow":"RowLayout_promptRow__2ZIeP","answerRow":"RowLayout_answerRow__3k2As","answerCard":"RowLayout_answerCard__3ayhw"};